import Avatar from "@mui/material/Avatar";

import type { CallContact } from "services/dialstack";

import { contactInitials, contactKindTint } from "./contact-kind.util";
import useContactPrivacySx from "./use-contact-privacy.hook";

// Initials tinted by kind, shared by the Rolodex rows, the detail hero and
// the workspace feed cards. A family contact is PHI-adjacent, so in privacy
// mode its initials blur like a patient's.
export default function ContactAvatar({
  contact,
  size = 40
}: {
  contact: Pick<CallContact, "name" | "kind">;
  size?: number;
}) {
  const tint = contactKindTint(contact.kind);
  const privacySx = useContactPrivacySx(contact.kind);
  return (
    <Avatar
      data-testid="contact-avatar"
      data-kind={contact.kind ?? "other"}
      sx={{
        width: size,
        height: size,
        bgcolor: tint.background,
        color: tint.color,
        fontSize: Math.round(size * 0.36),
        fontWeight: 700,
        ...privacySx
      }}
    >
      {contactInitials(contact.name)}
    </Avatar>
  );
}
